import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

const DefaultHeaderCell = ({ className, label }) => {
  return <div className={classNames("data-grid__header", className)}>{label}</div>;
};

DefaultHeaderCell.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string
};

DefaultHeaderCell.defaultProps = {
  className: "",
  label: ""
};

export default DefaultHeaderCell;



// WEBPACK FOOTER //
// ./src/components/Layout/DataGrid/DefaultHeaderCell.js